import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class PayoutNotification {
  @Expose({ name: 'invoice_no' })
  invoiceNumber: string;

  @Expose({ name: 'status_id' })
  statusId: number;

  @Expose({ name: 'name' })
  status: string;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  dateUpdated: Date;

  total: string;

  constructor(
    invoiceNumber: string,
    statusId: number,
    status: string,
    dateUpdated: Date,
    total: string
  ) {
    this.invoiceNumber = invoiceNumber;
    this.statusId = statusId;
    this.status = status;
    this.dateUpdated = dateUpdated;
    this.total = total;
  }

  static fromJson(json: Record<string, any>): PayoutNotification {
    return plainToInstance(PayoutNotification, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
